import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminMessages() {
  const [contact, setContact] = useState([]);
  const [commissions, setCommissions] = useState([]);
  const [tab, setTab] = useState("contact");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get("/admin/contact-messages"),
      api.get("/admin/commissions"),
    ]).then(([c, m]) => {
      setContact(c.data);
      setCommissions(m.data);
    }).finally(() => setLoading(false));
  }, []);

  const list = tab === "contact" ? contact : commissions;

  return (
    <div data-testid="admin-messages">
      <p className="eyebrow mb-3">Inbox</p>
      <h1 className="font-serif text-5xl font-light mb-10">Messages</h1>

      <div className="flex gap-8 border-b border-border mb-8">
        {[
          { k: "contact", label: `Contact · ${contact.length}` },
          { k: "commissions", label: `Commissions · ${commissions.length}` },
        ].map((t) => (
          <button
            key={t.k}
            onClick={() => setTab(t.k)}
            data-testid={`tab-${t.k}`}
            className={`eyebrow pb-4 border-b-2 -mb-px ${tab === t.k ? "border-foreground text-foreground" : "border-transparent text-muted-foreground hover:text-foreground"}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {loading ? <p className="eyebrow text-muted-foreground">Loading…</p> : list.length === 0 ? (
        <div className="py-20 text-center">
          <h3 className="font-serif text-3xl italic font-light">The inbox is quiet.</h3>
        </div>
      ) : (
        <div className="space-y-4">
          {list.map((m) => (
            <details key={m.id} className="border border-border p-6" data-testid={`message-${m.id}`}>
              <summary className="cursor-pointer list-none grid grid-cols-12 gap-4 items-center">
                <div className="col-span-3 eyebrow text-muted-foreground">{new Date(m.created_at).toLocaleDateString()}</div>
                <div className="col-span-4 font-serif text-lg">{m.name}</div>
                <div className="col-span-5 text-sm text-muted-foreground truncate">{tab === "contact" ? (m.subject || m.email) : (m.project_type || m.email)}</div>
              </summary>
              <div className="mt-5 pt-5 border-t border-border text-sm space-y-2">
                <p><span className="eyebrow mr-2">Email</span><a href={`mailto:${m.email}`} className="hair-link">{m.email}</a></p>
                {tab === "commissions" && (
                  <>
                    {m.project_type && <p><span className="eyebrow mr-2">Project</span>{m.project_type}</p>}
                    {m.budget && <p><span className="eyebrow mr-2">Budget</span>{m.budget}</p>}
                    {m.timing && <p><span className="eyebrow mr-2">Timing</span>{m.timing}</p>}
                  </>
                )}
                {tab === "contact" && m.subject && <p><span className="eyebrow mr-2">Subject</span>{m.subject}</p>}
                <div className="pt-3 whitespace-pre-wrap leading-relaxed">{m.message}</div>
              </div>
            </details>
          ))}
        </div>
      )}
    </div>
  );
}
